import { Component, input } from '@angular/core';

@Component({
  selector: 'app-edit',
  imports: [],
  templateUrl: './edit.html',
})
export class Edit {
  size = input("6");
}

